export default {
  getHead: () => {
    return [{ name: "회사명" }, { name: "점검구분" },   { name: "점검일" }, { name: "작성자" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 회사명
        case 1:
          return func.getContent(value).inspectChecked.join(", "); // 점검구분
        case 2:
          return func.getContent(value).점검일; // 점검일
        case 3:
          return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.점검일) {
      nav.dateTarget = "content$body.점검일";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
      case "회사명":
        return ["content$body.stdInfo.field_name*%[:default_skw]%"];
      case "점검구분":
        return ["content$body.inspectionTitle*%[:default_skw]%"];
      case "소속명":
        return ["content$body.stdInfo.department*%[:default_skw]%"];
      case "부서명":
        return ["content$body.stdInfo.com_name*%[:default_skw]%"];
      case "작성자":
        return "content$body.stdInfo.writer_name*%[:default_skw]%";
    }
    return [];
  },
};
